import script from "./SurveyNotifyDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SurveyNotifyDialog.vue?vue&type=script&setup=true&lang=js"

import "./SurveyNotifyDialog.vue?vue&type=style&index=0&id=a63adbba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a63adbba"]])

export default __exports__